<div id="content" [formGroup]="filterForm" class="extensible">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="page-title">
          <h1>{{ page_title }}</h1>

          <!-- aqui aniran els controls -->
          @if (isAllowedToSeeOtherUsers) {
            <mat-form-field appearance="outline" class="nobottom">
              <span matPrefix><mat-icon>person</mat-icon></span>
              <input
                [formControl]="userAutocompleteControl"
                type="text"
                placeholder="Escribe un nombre..."
                matInput
                [matAutocomplete]="auto"
              />
              <button id="reset-user-autocomplete" mat-icon-button (click)="resetUserAutocompleteControl()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFnUser" (optionSelected)="onUserAutocompleteSelected($event)">
                @for (user of filteredOptions | async; track user) {
                  <mat-option [value]="user">{{ user.name + ' ' + user.surnames }}</mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          }

          <div class="date-controller card">
            <button mat-icon-button (click)="changeWeek(-1)"><mat-icon>chevron_left</mat-icon></button>
            <span class="date">{{ filterForm.value['from'] | date: 'shortDate' }} - {{ filterForm.value['to'] | date: 'shortDate' }}</span>
            <button mat-icon-button (click)="changeWeek(1)"><mat-icon>chevron_right</mat-icon></button>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (summary != null) {
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="bisual-table-container sticky-table-container">
            <table mat-table [dataSource]="mainDataSource" class="sticky-table">
              <ng-container matColumnDef="category">
                <th mat-header-cell *matHeaderCellDef class="sticky-column-left sticky-header-cell">Categoría</th>
                <td
                  mat-cell
                  *matCellDef="let line; let i = index"
                  class="sticky-column-left"
                  [ngClass]="{
                    'sticky-cell-bg-light': line.backgroundColor === '#f8f9fa',
                    'sticky-cell-bg-white': !line.backgroundColor || line.backgroundColor === 'white',
                  }"
                >
                  @if (line.type === 'company_product') {
                    @if (line.is_first_subcategory) {
                      <a
                        [routerLink]="['/employees', 'development', 'company-products', line.primary_entity_id]"
                        [attr.rowspan]="line.parent_deep || 1"
                        class="entity-title-link"
                      >
                        {{ line.primary_entity_title }}
                      </a>
                    }
                  }
                  @if (line.type === 'category') {
                    <span class="entity-title-text">
                      {{ line.primary_entity_title }}
                    </span>
                  }
                  @if (line.type === 'subcategory' || line.type === 'phase') {
                    <!-- Empty cell for subcategories/phases (they use rowspan from parent) -->
                  }
                </td>
                <td mat-footer-cell *matFooterCellDef class="sticky-column-left sticky-footer-cell"><b>Resumen</b></td>
              </ng-container>
              <ng-container matColumnDef="sub_category">
                <th mat-header-cell *matHeaderCellDef class="sticky-column-left-2 sticky-header-cell">Subcategoría</th>
                <td
                  mat-cell
                  *matCellDef="let line; let i = index"
                  class="sticky-column-left-2"
                  [ngClass]="{
                    'sticky-cell-bg-light': line.backgroundColor === '#f8f9fa',
                    'sticky-cell-bg-white': !line.backgroundColor || line.backgroundColor === 'white',
                  }"
                >
                  @if (line.type === 'company_product') {
                    <!-- Vacío para productos -->
                  }
                  @if (line.type === 'category') {
                    <!-- Vacío para categorías -->
                  }
                  @if (line.type === 'subcategory' || line.type === 'phase') {
                    <span class="subcategory-text">
                      @if (line.spacesArray) {
                        @for (space of line.spacesArray; track space) {
                          <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        }
                      }
                      {{ line.secondary_entity_title }}
                    </span>
                  }
                </td>
                <td mat-footer-cell *matFooterCellDef class="sticky-column-left-2 sticky-footer-cell"></td>
              </ng-container>
              @for (dayCol of dayColumnHeaders; track dayCol.key; let i = $index) {
                <ng-container [matColumnDef]="dayCol.key">
                  <th mat-header-cell *matHeaderCellDef class="day-column day-column-header">{{ dayCol.header }}</th>
                  <td mat-cell *matCellDef="let line" class="day-column day-column-cell">
                    @if (line.days != null && line.days[i]) {
                      <span
                        (click)="line.days[i].isClickable ? openWorklogResume(line.days[i].worklogs) : null"
                        [ngClass]="{
                          'worklog-day-clickable': line.days[i].isClickable === true,
                          warn: line.days[i].flag === 'warn',
                          error: line.days[i].flag === 'error',
                        }"
                        [matTooltip]="line.days[i].tooltipText || ''"
                      >
                        {{ line.days[i].total_seconds_done | secondsToStringTime }}
                      </span>
                    }
                  </td>
                  <td mat-footer-cell *matFooterCellDef class="day-column day-column-footer">
                    {{ summary.days[i].done_hours * 3600 | secondsToStringTime }} /
                    {{ summary.days[i].total_hours * 3600 | secondsToStringTime }}
                  </td>
                </ng-container>
              }
              <ng-container matColumnDef="total_company_product">
                <th mat-header-cell *matHeaderCellDef class="sticky-column-right sticky-header-cell total-column-header">Total</th>
                <td
                  mat-cell
                  *matCellDef="let line; let i = index"
                  class="sticky-column-right total-column-cell"
                  [ngClass]="{
                    'sticky-cell-bg-light': line.backgroundColor === '#f8f9fa',
                    'sticky-cell-bg-white': !line.backgroundColor || line.backgroundColor === 'white',
                  }"
                >
                  <!-- Mostrar total de subcategoría -->
                  <span [ngClass]="line.total_seconds_subcat_expected > 0 ? line.flag : null">
                    {{ line.total_seconds_subcat_done | secondsToStringTime }}
                    @if (line.hasOwnExpected === true) {
                      / {{ line.total_seconds_subcat_expected | secondsToStringTime }}
                    }
                  </span>
                </td>
                <td mat-footer-cell *matFooterCellDef class="sticky-column-right sticky-footer-cell total-column-footer">
                  <div class="total-footer-content">
                    <!-- Horas principales -->
                    <div class="total-footer-main">{{ (summary.done_hours || 0) * 3600 | secondsToStringTime }} /</div>
                    <!-- Sumatorios en pequeño -->
                    <div class="total-footer-sums">
                      <span
                        matTooltip="Suma de horas esperadas de productos/categorías de primer nivel (sumatorio vertical)"
                        matTooltipPosition="above"
                        class="total-footer-sum-item"
                      >
                        {{ verticalExpectedSum | secondsToStringTime }}
                      </span>
                      <span
                        matTooltip="Suma de horas esperadas de cada día (sumatorio horizontal)"
                        matTooltipPosition="above"
                        class="total-footer-sum-item"
                      >
                        {{ horizontalExpectedSum | secondsToStringTime }}
                      </span>
                    </div>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="mainDisplayedColumnKeys" class="sticky-header"></tr>
              <tr
                mat-row
                rowspan="2"
                *matRowDef="let cat; let i = index; columns: mainDisplayedColumnKeys"
                [ngClass]="{
                  'parent-row': cat.type === 'company_product' || cat.type === 'category',
                  'row-bg-light': cat.rowBackgroundColor === '#f8f9fa',
                  'row-bg-white': !cat.rowBackgroundColor || cat.rowBackgroundColor === 'white',
                }"
              ></tr>
              <tr mat-footer-row *matFooterRowDef="mainDisplayedColumnKeys" class="sticky-footer"></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  }
</div>
